<style lang="less"></style>

<template>
    <MenuList :menuList="menuList" @handleClicks="handleClicks(...arguments)" />
</template>

<script lang="ts">
    declare var EDDocument: any;
    declare var eSnapFlags: any;
    import { Component, Prop, Vue } from "vue-property-decorator";
    import MenuList from "@/app/components/MenuList.vue";

    @Component({
        components: {
            MenuList,
        },
    })
    export default class gridMenus extends Vue {
        get menuList() {
            return {
                list: [
                    { label: this.$t("showGrid"), checked: this.isShowGrid, showVip: !this.vip },
                    { label: this.$t("snapGrid"), checked: this.isShowSnapGrid },
                    { label: this.$t("gridSetting") },
                ],
            };
        }
        handleClicks(...args) {
            let index = args[0];
            let clickEvents = new Map([
                [
                    0,
                    () => {
                        this.toggleGrid();
                    },
                ],
                [
                    1,
                    () => {
                        this.snapGrid();
                    },
                ],
                [
                    2,
                    () => {
                        this.gridSetting();
                    },
                ],
            ]);
            const onClicks = clickEvents.get(index);
            onClicks && onClicks();
        }
        closeDrop() {
            this.$emit("closeDrop");
        }
        get vipStateFuncList() {
            return this.$store.getters.vipStateFuncList;
        }
        toggleGrid() {
            let view = window["_view"];
            if (!view) return;

            let checked = !view._doc._config._showGrid;
            this.$track("menu", "view", "showGrid" + checked);
            if (this.vip || (!this.vip && checked)) {
                view.showGridBox(checked);
                this.updateToCloud({ showGrid: checked });
            } else {
                this.$store.commit("setStatus", {
                    type: "triggerType",
                    data: "removeGrid",
                });
                this.sensors.track("tryVipBenefit", {
                    Catalogues: "editFileProcess",
                    trial_vip_benefit: "removeGrid",
                });
                if (!this.internal && this.lang !== "zh") {
                    this.$store.commit("toPublicStatus", {
                        type: "upgradeTrigger",
                        data: "removeGrid",
                    });
                    this.$bus.$emit("togglePromodal", true, 0, 1);
                } else {
                    view.showGridBox(false);
                    this.$store.commit("setStatus", {
                        type: "removeGrid",
                        data: false,
                    });

                    let list = [];
                    list = this.vipStateFuncList.slice();
                    list.push("funcGrid");
                    this.$bus.$emit("toggleFuncVipTip", { visible: true, vipFuncs: list, upgradeTrigger: "removeGrid" });
                    this.$store.commit("closeContext");
                    // this.$openBuyPage("removeGrid");
                }
            }
            this.closeDrop();
        }
        snapGrid() {
            // 对齐网格
            let view = window["_view"];
            if (!view) return;
            let checked = EDDocument._gcfg._snapFlags & eSnapFlags.RulerSubDiv && EDDocument._gcfg._snapFlags & eSnapFlags.Grid;
            this.$track("menu", "view", "snapGrid" + checked);
            view.snapToGridBox(!checked);
            this.closeDrop();
        }
        gridSetting() {
            let ts: any = this;
            ts.$bus.$emit("changeRightViewActiveKey", "pageset");
            ts.$bus.$emit("changeRightView", "pageset", false, "other");
            this.$track("menu", "view", "gridSetting");
            this.closeDrop();
        }

        uploadTimer = 0;
        get userInfo() {
            return this.$store.state.user.userInfo;
        }

        get showGrid() {
            return this.$store.state.ui.showGrid;
        }

        set showGrid(v) {
            this.$store.commit("setStatus", {
                type: "showGrid",
                data: v,
            });
        }

        updateToCloud(obj, type?) {
            if (this.uploadTimer) {
                clearTimeout(this.uploadTimer);
            }
            this.uploadTimer = setTimeout(() => {
                let newShowGrid = obj.showGrid ? 1 : 0;
                this.showGrid = newShowGrid;
                let params = {
                    id: this.userInfo.user_id,
                    token: this.userInfo.token,
                    obj: { showGrid: newShowGrid },
                };
                if (this.userInfo)
                    this.$edApi.updateUserPrefer(params).then((e) => {
                        console.log(e);
                    });
            }, 500);
        }

        get isShowGrid() {
            return this.$store.state.page.showGrid;
        }
        get isShowSnapGrid() {
            return this.$store.state.page.showSnapGrid;
        }

        mounted() {}

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "showGrid": "显示网格",
    "snapGrid": "吸附网格",
    "gridSetting": "网格设置"
  },
  "en": {
    "showGrid": "Show Grid",
    "snapGrid": "Snap to Grid",
    "gridSetting": "Grid Settings"
  },
  "fr": {
    "showGrid": "Afficher la Grille",
    "snapGrid": "Accrocher à la Grille",
    "gridSetting": "Paramètres de grille"
  },
  "de": {
    "showGrid": "Gitternetzlinien anzeigen",
    "snapGrid": "Am Raster ausrichten",
    "gridSetting": "Gitternetzlinie einstellen"
  },
  "jp": {
    "showGrid": "グリッドを表示",
    "snapGrid": "グリッドにスナップ",
    "gridSetting": "グリッド設定"
  },
  "es": {
    "showGrid": "Mostrar cuadrícula",
    "snapGrid": "Encajar a la cuadricula",
    "gridSetting": "Configuración de la red"
  },
  "pt": {
    "showGrid": "Mostrar Grelha",
    "snapGrid": "Encaixar para Grelha",
    "gridSetting": "Configurações de Grelha"
  },
  "it": {
    "showGrid": "Mostra Griglia",
    "snapGrid": "Aggancia a Griglia",
    "gridSetting": "Impostazioni Griglia"
  },
  "tw": {
    "showGrid": "顯示網格",
    "snapGrid": "吸附網格",
    "gridSetting": "網格設置"
  }
}
</i18n>
